import { normalizeLayoutCategory } from './normalize-layout-category'
import { normalizeLayoutCatalog } from './normalize-layout-catalog'
import { normalizeLayoutGnb } from './normalize-layout-gnb'
import { normalizeLayoutFilter } from './normalize-layout-filter'
import { normalizeLayoutCampaign } from './normalize-layout-campaign'

export const normalizeLayout = (rawData) => {
  const {
    category = {},
    catalog = {},
    gnb = {},
    filter = {},
    campaign = {},
  } = rawData

  return {
    category: normalizeLayoutCategory(category),
    catalog: normalizeLayoutCatalog(catalog),
    gnb: normalizeLayoutGnb(gnb),
    filter: normalizeLayoutFilter(filter),
    campaign: normalizeLayoutCampaign(campaign),
  }
}
